import { Component, OnInit, NgZone } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-ctas',
  templateUrl: './ctas.component.html',
  styleUrls: ['./ctas.component.scss']
})
export class CtasComponent implements OnInit {

  ico1: AnimationOptions = {
    path: '../assets/animations/guarantee2.json',
    autoplay: false
  };
  ico2: AnimationOptions = {
    path: '../assets/animations/map-marker2.json',
    autoplay: false
  };
  ico3: AnimationOptions = {
    path: '../assets/animations/promo.json',
    autoplay: false,
  };
  arrow: AnimationOptions = {
    path: '../assets/animations/arrowWhite.json',
    autoplay: false
  };
  
  private animationItem: AnimationItem[] = [, , , , , ,];
 
  constructor(private ngZone: NgZone) { }

  ngOnInit() {
  }

  stop(index): void {
    this.ngZone.runOutsideAngular(() => this.animationItem[index].stop());
  }
 
  play(index): void {
    this.ngZone.runOutsideAngular(() => {
      // promo icon exception
      if (index == 2) {
         this.animationItem[index].playSegments([50, 125], true);
      } else { this.animationItem[index].play() }
      });

  }

  animationCreated(animationItem: AnimationItem, index: number): void {
    this.animationItem[index] = animationItem;
  }

}
